<!-- Hidden link für search engines to improve SEO -->
<a
  class="seo-link"
  tabindex="-1"
  [href]="'https://' + angebot.id"
  [routerLink]="['/']"
  queryParamsHandling="merge"
  [queryParams]="{ angebot: angebot.id }"
  [attr.aria-labelledby]="'angebot_' + angebot.id + '_heading'"
  aria-hidden="true"
></a>
<div class="now-card-tag">
  <span class="now-icon now-icon-calendar-blank"></span
  ><span class="now-card-tag-text">{{
    angebot.anzahlTermine | i18nPlural: anzahlTerminePlural
  }}</span>
</div>
<h2
  class="now-heading heading"
  [attr.id]="'angebot_' + angebot.id + '_heading'"
  nowWbsucheLibScrollToAndFocus
  [shouldScroll]="selected"
>
  <span [innerHTML]="breakTitle(angebot.titel)"></span>
  <span class="sr-only">Bildungsanbieter {{ angebot.bildungsanbieter.name }}</span>
</h2>
<div>
  <div class="fs-6 weiterbildungsart">{{ weiterbildungsart }}</div>
  <div class="row now-copytext">
    <div class="col-3 now-logo-column position-relative">
      <img
        [attr.id]="'angebot_' + angebot.id + '_logo'"
        class="now-image px-2"
        aria-hidden="true"
        [ngSrc]="anbieterLogo"
        fill
        alt="Logo des Anbieters"
        (error)="hasImgError = true"
      />
    </div>
    <div class="col-9">
      <p>
        <strong>Bildungsanbieter</strong><br />
        <span [attr.id]="'angebot_' + angebot.id + '_anbieter'">{{
          angebot.bildungsanbieter.name
        }}</span>
      </p>
    </div>
  </div>
</div>
